export default __webpack_public_path__ + "static/media/voucher_member.7b215201.csv";